import { apiProxyRequest } from "Api/apiProxyRequest";

import type { OrganizationAddress } from "./types";

export const getOrganizationAddressRequest = (organizationId: string) =>
  apiProxyRequest<OrganizationAddress>(
    `/organizations/${organizationId}/address`
  );
